import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TeamCustomSMWidget from '../../../../widgets/components/sm/TeamCustomSMWidget';
import WDPContext from '../../../../widgets/components/core/WDPContext';

function WidgetCustomLineUp({
    user = '',
    client = '',
    lang = 'en',
    timezone = 'CET',
    idLineUp,
    lineupType = '',
    players = []
}) {
    return (
        <WDPContext token="etst" social user={user} client={client}>
            <TeamCustomSMWidget
                title="Custom title"
                subTitle="Description"
                idLineUp={idLineUp}
                type={lineupType}
                players={players}
                lang={lang}
                tz={timezone}
                template={localStorage.getItem('C_DEFAULT_TEMPLATE')}
            />
        </WDPContext>
    );
}

WidgetCustomLineUp.propTypes = {
    user: PropTypes.string,
    client: PropTypes.string.isRequired,
    lang: PropTypes.string.isRequired,
    timezone: PropTypes.string.isRequired,
    idLineUp: PropTypes.number.isRequired,
    lineupType: PropTypes.string.isRequired,
    players: PropTypes.array.isRequired
};

export default connect(({ user, makerToolPage }) => ({
    user: user.username,
    client: user.client,
    lang: user.props && user.props.lang,
    timezone: user.props && user.props.timezone,
    idLineUp: makerToolPage.idLineUp,
    lineupType: makerToolPage.lineupType,
    players: makerToolPage.customPitchLineupList
}))(WidgetCustomLineUp);



/** WEBPACK FOOTER **
 ** ../src/dash/front/grid-maker-tool-page/components/WidgetCustomLineUp.js
 **/